<h2 mat-dialog-title class="modal-add-header"><mat-icon class="with-text" color="white" >add</mat-icon>เพิ่มโรงพยาบาล</h2>
<form [formGroup]="fg" (ngSubmit)="onSubmit()" #form>
  <mat-dialog-content>
    <mat-form-field>
      <mat-label>ชื่อโรงพยาบาล</mat-label>
      <input matInput formControlName="name" placeholder="ชื่อโรงพยาบาลที่ใช้ในการแสดงผล">
      <mat-error>{{ messageError.TH.addHospitalHospitalNameMissing}}</mat-error>
    </mat-form-field>
    <br>
    <mat-form-field>
      <mat-label>เลขรหัสของโรงพยาบาล</mat-label>
      <input matInput formControlName="displayId" placeholder="เลขรหัสของโรงพยาบาล">
      <mat-error *ngIf="fg.get('displayId').getError('required')">{{ messageError.TH.addHospitalHospitalIDMissing}}</mat-error>
      <mat-error *ngIf="fg.get('displayId').getError('duplicate')">{{ messageError.TH.addHospitalHospitalIDDuplicate}}</mat-error>
    </mat-form-field>
    <!-- <br>
    <mat-form-field class="form-short">
      <mat-label>ละติจูด</mat-label>
      <input matInput placeholder="เช่น 13.7678855">
    </mat-form-field>, 
    <mat-form-field class="form-short">
      <mat-label>ลองจิจูด</mat-label>
      <input matInput placeholder="เช่น 100.5341847">
    </mat-form-field> -->

    <!--  -->

    <br>
    <mat-form-field>
      <mat-label>เลือกไฟล์รูปภาพ</mat-label>
      <input matInput readonly="true" placeholder="เลือกไฟล์รูปภาพ" formControlName="displayLogoName" (click)="fileUpload.click()">
      <mat-hint>{{messageError.TH.addHospitalHintLogo}}</mat-hint>
      <mat-error >{{messageError.TH.addHospitalLogoBigger}}</mat-error>
      <!-- <input matInput readonly="true" value="* upload file more than 200k" *ngIf="fileSizeError" style="color:red"> -->
    </mat-form-field>
    <button type="button" class="browseButton" mat-raised-button (click)="fileUpload.click()">เลือกรูปภาพ</button>
    
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class="flex-spacer"></div>
    <button type="button" mat-raised-button mat-dialog-close [mat-dialog-close]="false">ยกเลิก</button>
    <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
    <button mat-raised-button class="submit-button">บันทึก</button>
  </mat-dialog-actions>
</form>
<input type="file" readonly="true" placeholder="เลือกไฟล์รูปภาพ" accept="image/*" (change)="onFileChange($event)" #fileUpload style="display:none">
